<ppl-accordion [title]="'Processed Invoice'" [isOpen]="true">
    <div class="w-100">
        <ppl-invoice-filter (searchEvent)="onSearch($event)" [filterFields]="filterFields"
            [includeBusinessStatus]="['P', 'D', 'CD']" [consumerList]="consumers"></ppl-invoice-filter>

        @if(!invoices || invoices.length == 0) {
        <div class="alert alert-warning"><strong>No Records Found. </strong>Please change the filters to find
            the
            records</div>
        }
    </div>
    @if(invoices.length > 0) {
    <div class="table-style">
        <ppl-list-table rowDataAccessibilityKey="payrollScheduleId" [disableSort]="true" [disableSearch]="true" [showCustomSearch]="false"
            [data]="invoices" (rowDetailEvent)="rowClicked($event)" (rowDetailEventTs)="rowActions($event)" [disableSelection]="true" [cols]="cols"
            (gridAction)="onAction($event)" [gridTitle]="false" [pagination]="true" [loadPage]="true" [recordsPerPage]="10" [customDataLoaded]="true" (onPageLoad)="onPageLoad($event)"
            [actionButtons]="actionButtons" [showExpandIcon]="true" [showLineItem]="true" [lineItemCols]="lineItemCols"
            [cellClassResolver]="serviceDatesCellClassResolver">
        </ppl-list-table>
    </div>
    }
</ppl-accordion>

<div class="filter-panel">
  <ng-template #invoiceViewDialog let-cancel="cancel">
    <ppl-add-invoice [providerId]="providerId" [consumers]="consumers" [mode]="mode" [provider]="provider" [invoiceId]="invoiceId" [consumerId]="selectedLineItem?.consumerId"
      [providerView]="true" (invoiceSaved)="handleCancel($event)" (cancel)="handleCancel($event)"></ppl-add-invoice>
  </ng-template>
</div>


<div class="filter-panel">
    <ng-template #pdfDialog let-cancel="cancel">
        <div class="" *ngIf="pdfConfig && pdfFile">
            <ppl-editpdf (fieldsUpdated)="fieldsUpdated($event)" [readonly]="true" [pdfConfig]="pdfConfig"
                [signature]="" [pdfBlob]="pdfBlob" [pdfFile]="pdfFile" [signatureId]=""
                [isParticipantFlow]="false" [selectedParticipantId]="0"
                [isSelf]="true"></ppl-editpdf>
        </div>
    </ng-template>
  </div>
